import { useMutation } from '@apollo/client'
import { ModalForm, TextInput, useForm } from '@faceup/form'
import { defineMessages, useIntl } from '@faceup/localization'
import { SHORT_STRING_MAX_LENGTH } from '@faceup/utils'
import { yup } from '@faceup/validation'
import { graphql } from '../../__generated__'

const messages = defineMessages('followUp.pages.searchInstitution.sendUnregisteredSchoolTipModal', [
  { id: 'title', defaultMessage: 'Which school can’t you find?' },
  { id: 'schoolName', defaultMessage: 'School name' },
  {
    id: 'sendSchoolSuccess',
    defaultMessage: 'Your request to add a school has been successfully accepted.',
  },
] as const)

const mutations = {
  SendUnregisteredSchoolTipMutation: graphql(`
    mutation SendUnregisteredSchoolTipMutation(
      $input: SendUnregisteredSchoolTipInput!
    ) {
      sendUnregisteredSchoolTip(input: $input) {
        success
      }
    }
  `),
}

type SendUnregisteredSchoolTipModalProps = {
  open: boolean
  onClose: () => void
}

export const SendUnregisteredSchoolTipModal = ({
  open,
  onClose,
}: SendUnregisteredSchoolTipModalProps) => {
  const { formatMessage } = useIntl()

  const schema = yup.object({
    schoolName: yup.string().max(SHORT_STRING_MAX_LENGTH).required(),
  })

  const form = useForm({
    schema,
    afterSubmit: 'resetValues',
  })

  const [suggestMutation] = useMutation(mutations.SendUnregisteredSchoolTipMutation, {
    onCompleted: () => {
      onClose()
    },
  })

  return (
    <ModalForm
      customSubmitSuccessText={formatMessage(messages.sendSchoolSuccess)}
      width={620}
      open={open}
      onClose={onClose}
      onSubmit={async ({ schoolName }) => {
        const result = await suggestMutation({
          variables: {
            input: {
              schoolName,
            },
          },
        })

        if (result.errors) {
          return false
        }

        return result.data?.sendUnregisteredSchoolTip?.success ?? false
      }}
      form={form}
      submitButtonText='send'
      title={formatMessage(messages.title)}
    >
      <TextInput
        label={formatMessage(messages.schoolName)}
        control={form.control}
        name='schoolName'
      />
    </ModalForm>
  )
}
